export default __webpack_public_path__ + "static/media/WorkSans-Regular.4cdecb22.ttf";